import { render } from "./ProcessesList.vue?vue&type=template&id=05d22e28&scoped=true"
import script from "./ProcessesList.vue?vue&type=script&lang=js"
export * from "./ProcessesList.vue?vue&type=script&lang=js"

import "./ProcessesList.vue?vue&type=style&index=0&id=05d22e28&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05d22e28"]])

export default __exports__